import { ReactNode } from "react"

interface InlineLinkProps {
    link?: string
    text?: ReactNode
}

const InlineLink = ({ link, text }: InlineLinkProps) => {
    return (
        <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#0C66E4] hover:underline inline-block align-top max-w-full truncate"
        >
            {text || link}
        </a>
    )
}

export default InlineLink